import SourceObjectValue from "@mapmycustomers/shared/types/SourceObjectValue";
import { isNotEmptyString } from "@mapmycustomers/shared/util/assert";

import { RESERVED_PINNED_LIST_KEYS } from "../constants";

const isSubtypeKey = (key: SourceObjectValue["key"]): key is string =>
  isNotEmptyString(key) && !RESERVED_PINNED_LIST_KEYS.includes(key);

// Mobile's gate (more than one source object for the record type), deliberately not web's
// hasCustomSourceObjects, so web and mobile agree on which records get a subtype list.
const getPinnedSubtypeKeys = (values: SourceObjectValue[] | undefined): string[] =>
  values && values.length > 1 ? values.map(({ key }) => key).filter(isSubtypeKey) : [];

export default getPinnedSubtypeKeys;
